<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
  >
    <NoBikeBillDetail v-if="form.type == 4" ref="noBikeBillDetail"/>
    <BillDetail v-else ref="billDetail"/>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import BillDetail from './billDetail.vue'
import NoBikeBillDetail from './noBikeBillDetail.vue'
export default {
  name: 'OperaSitesWindow',
  extends: BaseOpera,
  components: { GlobalWindow, BillDetail, NoBikeBillDetail },
  data () {
    return {
      // 表单数据
      form: {
        endDate: '',
        startDate: '',
        type: ''
      },

    }
  },
  created () {
    this.config({
      api: '/business/sites',
      'field.id': 'id'
    })
  },
  methods: {
    open (title, target) {
      this.title = title
      this.visible = true
      // 新建
      this.form = target
      this.$nextTick(() => {
        console.log(target)
        if (target.type == 4) {
          this.$refs.noBikeBillDetail.reload({ ...target, isBikeFee: 1 })
        } else {
          this.$refs.billDetail.reload(target)
        }
      })
    },
  },

}
</script>
